/**
 * Engraving Product Form Integration
 * Handles integration between product form and engraving selector
 */

class EngravingProductForm {
  constructor() {
    this.core = window.engravingCore;
    this.cart = window.engravingCart;
    this.init();
  }

  /**
   * Initialize product form integration
   */
  init() {
    // Listen for product form submissions
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (form) {
        this.handleFormSubmit(e, form);
      }
    });

    // Listen for engraving changes
    document.addEventListener('engraving:change', (e) => {
      // Update form data if needed
    });
  }

  /**
   * Handle product form submission
   * @param {Event} e - Submit event
   * @param {HTMLFormElement} form - Form element
   */
  async handleFormSubmit(e, form) {
    const engravingSelector = form.closest('product-form')?.querySelector('engraving-selector');
    
    if (!engravingSelector) {
      return; // No engraving selector, proceed normally
    }

    const selector = engravingSelector;
    
    // Validate engravings
    const validation = selector.validate();
    if (!validation.valid) {
      e.preventDefault();
      alert(validation.errors.join('\n'));
      return;
    }

    // Get engravings
    const engravings = selector.getSelectedEngravings();
    
    // If engraving is enabled but no engravings, prevent submission
    const mainCheckbox = selector.querySelector('.engraving-selector__checkbox');
    if (mainCheckbox && mainCheckbox.checked && engravings.length === 0) {
      e.preventDefault();
      alert('Please add at least one engraving or disable engraving');
      return;
    }

    // If no engravings, proceed normally
    if (engravings.length === 0) {
      return;
    }

    // Store engravings for after product is added
    form.dataset.engravings = JSON.stringify(engravings);
    
    // Let form submit normally, then add engravings after product is added
    form.addEventListener('product:added', async (event) => {
      const response = event.detail;
      if (response && response.key) {
        await this.addEngravingsToNewItem(response.key, engravings, response.quantity || 1);
      }
    }, { once: true });
  }

  /**
   * Add engravings to newly added cart item
   * @param {string} lineItemKey - Cart line item key
   * @param {Array} engravings - Array of engraving objects
   * @param {number} quantity - Item quantity
   */
  async addEngravingsToNewItem(lineItemKey, engravings, quantity) {
    try {
      if (!this.cart) {
        console.warn('Engraving cart not available');
        return;
      }

      await this.cart.addEngravings(lineItemKey, engravings, quantity);
    } catch (error) {
      console.error('Failed to add engravings to new item:', error);
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.engravingProductForm = new EngravingProductForm();
  });
} else {
  window.engravingProductForm = new EngravingProductForm();
}


